const QuickLinksList = props => {
  const { children } = props
  let quickLinksListClassName = 'content--centered quicklink__container'
  if (children.length >= 5 && children.length % 3 === 2) {
    quickLinksListClassName += ' fill-space'
  }

  return (
    children &&
      <div class={quickLinksListClassName}>
        {children}
      </div>
  )
}

export default QuickLinksList
